import { loginService } from "../../helpers/loginService";
import { userService } from "../../helpers/userService";

export const state = {
  getAllUser: [],
  getRecords: "",
  loading: false,
  userCount: "",
  pagination: {},
  user: {
    name: "",
    email: "",
    profile_image: null,
    status: 1,
  },
  getAllSetting: {},
  getUserBookingReportByYear: {},
  getUserEarningReportByYear: {},
  totalBookingUserUnit:0,
  totalBookingUserTime:0
};
export const mutations = {
  getUserListRequest(state) {
    state.loading = true;
  },
  getAllUser(state, payload) {
    state.getAllUser = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.userCount = payload.result.total;
  },
  getUserListFailure(state) {
    state.loading = false;
  },
  getUser(state, payload) {
    state.user = payload.result;
  },
  getAllSetting(state, payload) {
    state.getAllSetting = payload.result;
  },
  getUserBookingReportByYear(state, payload) {
    var result = [];
    payload.data.forEach(function (payload) {
      var data = {
        x: payload.x,
        y: payload.y,
      };
      result.push(data);
    });
    state.getUserBookingReportByYear = result;
    state.totalBookingUserUnit = payload.charging_unit;
    state.totalBookingUserTime = payload.charging_time;
  },
  getUserEarningReportByYear(state, payload) {
    var result = [];
    payload.forEach(function (payload) {
      var data = {
        x: payload.x,
        y: payload.y,
      };
      result.push(data);
    });
    state.getUserEarningReportByYear = result;
  },
};

export const actions = {
  async Login({ commit }, data) {
    return new Promise((resolve) => {
      loginService.CheckLogin(data).then(
        (response) => {
          localStorage.setItem(
            "token",
            JSON.stringify(response.data.result.token)
          );
          localStorage.setItem(
            "user_name",
            JSON.stringify(response.data.result.full_name)
          );
          localStorage.setItem(
            "profile_image",
            JSON.stringify(response.data.result.profile_image)
          );
          resolve(response);
        },
        (error) => {
          commit("error", error);
        }
      );
    });
  },

  async Logout({ commit }) {
    return new Promise((resolve) => {
      let token = JSON.parse(localStorage.getItem("token"));
      window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      loginService.CheckLogout(token).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          commit("error", error);
        }
      );
    });
  },

  async getUsers({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserListRequest");
    await userService.getUsers(data).then(
      (response) => {
        commit("getAllUser", response.data);
      },
      (error) => {
        commit("getUserListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getUser({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise((resolve) => {
      userService.getUserData(data).then(
        (response) => {
          commit("getUser", response.data);
          resolve(response);
          //dispatch("getSetting");
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async getSetting({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise(() => {
      userService.getSetting(data).then(
        (response) => {
          commit("getAllSetting", response.data);
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async addUser({ dispatch, commit },data){
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise((resolve) => {
      userService.addUser(data)
      .then((response)=>{
        if(response.data.code == 200){
          commit("getUser", response.data);
          resolve(response);
        }else{
          dispatch("alert/error", response.data.msg, { root: true });
        }
      }).catch((error)=>{
        dispatch("alert/error", error, { root: true });
      });
    })
  },
  async updateUser({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise((resolve) => {
      userService.updateUser(data).then(
        (response) => {
          commit("getUser", response.data);
          resolve(response);
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async blockById({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise((resolve) => {
      userService.blockById(data).then(
        (response) => {
          commit("getUser", response.data);
          resolve(response);
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async unblockById({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise((resolve) => {
      userService.unblockById(data).then(
        (response) => {
          commit("getUser", response.data);
          resolve(response);
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async ChangePassword({ dispatch }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return new Promise((resolve) => {
      loginService.ChangePassword(data).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async ForgotPassword({ dispatch }, data) {
    return new Promise((resolve) => {
      loginService.ForgotPassword(data).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch("alert/error", error, { root: true });
        }
      );
    });
  },

  async deleteUser({ dispatch, commit }, data) {
    return new Promise((resolve) => {
      let token = JSON.parse(localStorage.getItem("token"));
      window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      userService.deleteUser(data).then(
        (response) => {
          dispatch("getAllUser");
          resolve(response);
        },
        (error) => {
          commit("error", error);
        }
      );
    });
  },

  async getMonthWiseUserBookingReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await userService.getMonthWiseUserBooking(data).then((response) => {
      if (response.status == 200) {
        commit("getUserBookingReportByYear", response.data);
      } else {
        commit("getUserListFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getMonthWiseUserEarningReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await userService.getMonthWiseUserEarning(data).then((response) => {
      if (response.status == 200) {
        commit("getUserEarningReportByYear", response.data);
      } else {
        commit("getUserListFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },
};

export const getters = {
  getAllUser: (state) => state.getAllUser,
  loading: (state) => state.loading,
  userCount: (state) => state.userCount,
  pagination: (state) => state.pagination,
  userData: (state) => state.getUser,
  getAllSetting: (state) => state.getAllSetting,
  getUserBookingReportByYear: (state) => state.getUserBookingReportByYear,
  getUserEarningReportByYear: (state) => state.getUserEarningReportByYear,
  totalBookingUserUnit: (state) => state.totalBookingUserUnit,
  totalBookingUserTime: (state) => state.totalBookingUserTime
};
